"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LanguageRussianFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LanguageRussianFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.265 6.28h.368c.261 0 .474.027.64.08.17.048.296.128.376.24.085.107.128.25.128.432a.83.83 0 0 1-.112.44.675.675 0 0 1-.36.264 1.978 1.978 0 0 1-.648.088h-.392V6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM6 5.48c-.335-.128-.762-.192-1.28-.192H3.058V11h1.208V8.808h.648L6.273 11h1.344l-1.68-2.488c.186-.085.36-.195.52-.328A1.486 1.486 0 0 0 7 7c0-.384-.083-.701-.248-.952-.166-.256-.416-.445-.752-.568Zm6.722 4.576c.176-.32.264-.677.264-1.072V5.288h-1.208v3.488c0 .293-.04.536-.12.728a.79.79 0 0 1-.36.424c-.165.09-.381.136-.648.136-.379 0-.664-.096-.856-.288-.192-.192-.288-.523-.288-.992V5.288H8.298v3.68c0 .635.197 1.147.592 1.536.395.384.97.576 1.728.576.533 0 .973-.09 1.32-.272.352-.187.613-.437.784-.752Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LanguageRussianFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LanguageRussianFill;
exports["default"] = _default;